// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"6c6ace18","574":"6c6ace18","583":"6c6ace18","760":"95a302cc"}[chunkId] + ".chunk.css";
};